<template>
  <div class="resultBox">
    <van-nav-bar
      class="main-nav"
      left-arrow
      left-text=""
      title="测试结果"
      @click-left="onClickLeft"
    />
    <div
      v-loading="loading"
      class="result"
      element-loading-text="数据加载中..."
    >
      <div class="result_box">
        <!-- <div class="result_box_button">
          <div v-if="status === 2" @click="goRetest">重新测评</div>
        </div> -->
        <img
          v-if="userType == 'PARENT'"
          class="top_head"
          src="@/assets/images/test-center/result1.png"
        />
        <img
          v-else
          class="top_head"
          src="@/assets/images/test-center/result2.png"
        />
        <div class="result_content">
          <div class="score_title">您的当前分数</div>
          <div class="score_box">
            <van-circle
              stroke-width="60"
              layer-color="rgba(0, 145, 255,0.2)"
              v-model="num"
              :rate="num"
              :color="gradientColor"
            >
            <template slot="default">
              <div class="circularNum">
                <span>{{ num1 }}</span>分
              </div>
            </template>
            </van-circle>
            <!-- <div class="score">分</div> -->
          </div>
          <div v-if="detail" class="detail">
            <div v-for="(item,index) in detail">
              <div  v-for="(value,key,index) in item" class="detail_box">
                <span>{{ key }}</span>
                <span v-if="value!= null">:</span>
                <div>{{ value }}</div>
              </div>
            </div>

           
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { _invertResult } from "../../api/test-center";
import { verticalScreen } from "../../assets/js/vertical-screen";
import { decryptBy } from "@/assets/js/encryption";

import Cookies from "js-cookie";

export default {
  name: "result",
  data() {
    return {
      loading: false, //加载
      title: "", // 问卷名称
      num: 0, // 测评分数
      num1: 0,
      resultId: "", // id标识
      projectUrl: "", // 重新测评地址
      status: 2, //重新测评标识
      content:
        "小朋友表现非常棒，超级认真的完成了我们的测试。你是一个很开心快乐的小朋友，几乎总是保持着充沛的精力和满满的好奇心，每天都很有动力和积极性，这是非常棒的，请继续保持呀！现在你已经结束了测试，去其他空间看看有没有你感兴趣的活动吧。",
      list: [], //测评结果列表
      userType: "", //用户类型
      gradientColor: {
        "0%": "#0091FF",
        "100%": "#0091FF",
      },
      detail:''
    };
  },
  created() {
    this.resultId = this.$route.query.resultId;
    this.invertResult();
    let info = localStorage.getItem("userInfo");
    if (info) {
      let user = JSON.parse(decryptBy(info));
      if (user) {
        this.userType = user.userType;
      }
    }
  },
  mounted() {
    verticalScreen();
  },
  methods: {
    // 返回
    onClickLeft() {
      this.$router.go(-1);
    },
    // 获取测评结果
    invertResult() {
      _invertResult(this.resultId).then((res) => {
        this.loading = false;
        if (res && res.code === 200) {
          if (res.data) {
            this.num = Number(res.data.score);
            this.num1 = Number(res.data.score);
            let output = res.data.output;
            output = output.map((item,index)=>{
              return {
                [item.situationName+' : '+ item.situationScore + '分'] : null,
                [item.default+' : ' + item[item.default]]: null,
              }
            })
            this.detail = output;
            
            this.list =
              res.data.output && res.data.output.length > 0
                ? res.data.output
                : [];
            this.projectUrl = res.data.projectUrl;
            this.title = res.data.projectName;
            this.status = res.data.status;
          } else {
            this.num = 0;
          }
        } else {
          this.$toast(res.message);
        }
      });
    },
    // 重新测评
    goRetest() {
      this.$router.push({
        path: "/test",
        query: {
          projectUrl: this.projectUrl,
          title: this.title,
        },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.resultBox {
  height: 100%;
  padding-top: 44px;
  padding-bottom: 10px;
  background: #f5f7fa;
  .main-nav {
    position: fixed;
    width: 100%;
    top: 0;
  }
}
::v-deep .van-circle {
  .van-circle__text {
    font-size: 34px;
    color: #333;
    font-weight: 600;
    margin-left: -8px;
  }
}
.result {
  min-height: 100%;
  width: 100%;

  .result_box {
    height: 93%;
    width: 100%;
    border-radius: 16px;
  }
  .top_head {
    width: 375px;
    height: 216px;
  }
  .result_content {
    width: 335px;
    // height: 200px;
    padding-bottom: 30px;
    position: relative;
    margin: auto;
    background: #ffffff;
    border-radius: 20px;
    margin-top: -90px;
    text-align: center;
    .score_title {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #949c9d;
      line-height: 20px;
      display: inline-block;
      margin-top: 16px;
    }
    .score_box {
      margin-top: 16px;
      position: relative;
      .score {
        position: absolute;
        font-size: 16px;
        color: #999;
        top: 46px;
        left: 182px;
      }
    }
  }
  .result_box_button {
    display: flex;
    justify-content: flex-end;

    div {
      width: 99px;
      height: 30px;
      background: linear-gradient(360deg, #ff7f30 0%, #ffbc97 100%);
      border-radius: 15px;
      font-size: 14px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #ffffff;
      text-align: center;
      line-height: 30px;
      margin: 18px 18px 0 0;
    }
  }

  .result_box_title {
    margin-top: 40px;

    .result_box_title_top {
      display: flex;
      justify-content: space-evenly;
      min-height: 40px;

      .result_box_title_top_left {
        font-size: 18px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333;
        line-height: 40px;
        width: 198px;
      }

      .result_box_title_top_right {
        font-size: 28px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #ff9c4e;
        line-height: 40px;
        margin-left: 12px;
      }
    }

    .result_box_title_bot {
      margin-top: 19px;
      width: 291px;
      text-align: center;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #666666;
      line-height: 20px;
      margin-left: 27px;
    }

    .resultList {
      padding: 10px 29px;

      .resultList-title {
        display: flex;

        img {
          margin: 2px 0;
          width: 23px;
          height: 18px;
        }
      }

      .resultList-text {
        margin-top: 10px;
      }
    }
  }

  .result_box_img {
    width: 199px;
    height: 170px;
    margin-left: 73px;
    margin-top: 20px;
  }
}

::v-deep .van-icon {
  color: #000;
}
.detail {
  margin-top: 20px;
  width: 295px;
  margin-left: 20px;
  .detail_box {
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #2E4344;
    text-align: left;
    
  }
}
.circularNum {
  font-size: 16px;
  color: #000;
  span {
    font-weight: 600;
    line-height: 100px;
    font-size: 24px;
  }
}
</style>
